import { variables } from '@indriver/yrel';

var preset = {
  size: {
    xxs: '20px',
    xs: '24px',
    s: '32px',
    m: '40px',
    l: '48px',
    xl: '56px',
    xxl: '64px',
    xxxl: '80px',
    xxxxl: '120px'
  },
  backgroundColor: {
    success: variables['extensions-background-lightsuccess'],
    secondary: variables['background-secondary'],
    accent: variables['extensions-background-lightaccent'],
    error: variables['extensions-background-lighterror'],
    'error-inverse': variables['background-primary'],
    neutral: variables['background-secondary'],
    'neutral-inverse': variables['background-primary'],
    disabled: variables['background-disabled'],
    air: variables['information-light-airlight'],
    earth: variables['information-light-earthlight'],
    fire: variables['information-light-firelight'],
    sand: variables['information-light-sandlight'],
    sense: variables['information-light-senselight'],
    storm: variables['information-light-stormlight'],
    water: variables['information-light-waterlight'],
    wind: variables['information-light-windlight']
  },
  contentSize: {
    xxs: variables['font-size-xxs'],
    xs: variables['font-size-s'],
    s: variables['font-size-m'],
    m: variables['font-size-ml'],
    l: variables['font-size-l'],
    xl: variables['font-size-xl'],
    xxl: variables['font-size-xxl'],
    xxxl: variables['font-size-xxl'],
    xxxxl: variables['font-size-xxxl']
  },
  contentLineHeight: {
    xxs: variables['line-height-xxs'],
    xs: variables['line-height-s'],
    s: variables['line-height-m'],
    m: variables['line-height-ml'],
    l: variables['line-height-l'],
    xl: variables['line-height-xl'],
    xxl: variables['line-height-xxl'],
    xxxl: variables['line-height-xxl'],
    xxxxl: variables['line-height-xxxl']
  },
  contentFontWeight: {
    xxs: 500,
    xs: 500,
    s: 700,
    m: 700,
    l: 700,
    xl: 700,
    xxl: 700,
    xxxl: 700,
    xxxxl: 700
  },
  iconSize: {
    xxs: '10px',
    xs: '12px',
    s: '16px',
    m: '20px',
    l: '24px',
    xl: '28px',
    xxl: '32px',
    xxxl: '40px',
    xxxxl: '60px'
  },
  contentColor: {
    success: variables['extensions-text-and-icon-success'],
    secondary: variables['text-and-icon-primary'],
    accent: variables['text-and-icon-accent'],
    error: variables['extensions-text-and-icon-error'],
    'error-inverse': variables['extensions-text-and-icon-error'],
    neutral: variables['text-and-icon-secondary'],
    'neutral-inverse': variables['text-and-icon-primary'],
    disabled: variables['text-and-icon-disabled'],
    air: variables['information-medium-airmedium'],
    earth: variables['information-medium-earthmedium'],
    fire: variables['information-medium-firemedium'],
    sand: variables['information-medium-sandmedium'],
    sense: variables['information-medium-sensemedium'],
    storm: variables['information-medium-stormmedium'],
    water: variables['information-medium-watermedium'],
    wind: variables['information-medium-windmedium']
  },
  overlay: variables['extensions-background-overlaylight']
};

export { preset as default };
